<!--积分受理-->
<template>
  <Card class="points_wrap">
    <div class="main" v-show="integralUnit==0">
      <Form ref="formValidate" :label-width="150" :model="form" :rules="ruleValidate" class="form">
        <Row :gutter="16">
          <Col span="12">
          <FormItem label="需要申请办理的业务" prop="applicationType">
            <Select v-model="form.applicationType" :disabled="type>0">
              <Option v-for="item in otherApplicationTypeList" :key="item.value" :value="item.value">{{ item.text }}</Option>
            </Select>
          </FormItem>
          </Col>
          <Col span="12">
          </Col>
          <Col span="12">
          <FormItem label="单位名称" prop="enterpriseName">
            <Input v-model="form.enterpriseName" disabled placeholder="自动回显"></Input>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="社会统一信用代码" prop="enterpriseCode">
            <Input v-model="form.enterpriseCode" disabled placeholder="自动回显"></Input>
          </FormItem>
          </Col>
          <Col span="24">
          </Col>
          <Col span="12">
          <FormItem label="人事姓名" prop="personnelId">
            <Select v-model="form.personnelId" @on-change="personnelChange">
              <Option v-for="item in enterpriseAgentList" :key="item.enterpriseId" :value="item.value">{{ item.name }}</Option>
            </Select>
          </FormItem>
          </Col>
          <Col span="12">
          <FormItem label="人事身份证号" prop="personnelIDCardNo">
            <Input v-model="form.personnelIDCardNo" disabled placeholder="根据选择的人事显示"></Input>
          </FormItem>
          </Col>
          <Col span="24">
          <FormItem label="人事联系方式" prop="personnelPhone">
            <Input v-model="form.personnelPhone" disabled placeholder="根据选择的人事显示"></Input>
          </FormItem>
          </Col>
        </Row>
        <Spin size="large" fix v-if="loading"></Spin>
      </Form>
      <div class="bom_btn">
        <Button type="primary" @click="next(form.applicationType,'formValidate')">下一步</Button>
      </div>
    </div>
    <password-reset v-if="integralUnit==$store.state.otherApplicationTypeList.find((applicationType) => {
        return applicationType.text == '密码重置'
      }).value" @openQrCodeUpload="openQrCodeUpload" :uniPersonalList="uniPersonalList" @handleMaxSize="handleMaxSize" @setResult="setResult" @handleView="handleView" :form="form" @next="next" @handleSuccess="handleSuccess"
      @handleFormatError="handleFormatError" @handleRemove="handleRemove"></password-reset>

    <integral-unit-index v-if="integralUnit==$store.state.otherApplicationTypeList.find((applicationType) => {
        return applicationType.text == '单位开户/单位信息变更'
      }).value" @openQrCodeUpload="openQrCodeUpload" @setResult="setResult" :form="form" @handleMaxSize="handleMaxSize" @next="next" @handleView="handleView" @handleSuccess="handleSuccess" @handleFormatError="handleFormatError"
      @handleRemove="handleRemove"></integral-unit-index>

    <unit-change v-if="integralUnit==$store.state.otherApplicationTypeList.find((applicationType) => {
        return applicationType.text == '有效期内变更单位'
      }).value" @openQrCodeUpload="openQrCodeUpload" :form="form" @next="next" @handleMaxSize="handleMaxSize" @setResult="setResult" @handleView="handleView" @handleSuccess="handleSuccess" @handleFormatError="handleFormatError"
      @handleRemove="handleRemove"></unit-change>

    <address-change v-if="integralUnit==$store.state.otherApplicationTypeList.find((applicationType) => {
        return applicationType.text == '积分有效期内变更居住地址'
      }).value" @openQrCodeUpload="openQrCodeUpload" :form="form" @next="next" @handleMaxSize="handleMaxSize" @setResult="setResult" @handleView="handleView" @handleSuccess="handleSuccess" @handleFormatError="handleFormatError"
      @handleRemove="handleRemove"></address-change>
    <unit-withdraw v-if="integralUnit==$store.state.otherApplicationTypeList.find((applicationType) => {
        return applicationType.text == '单位撤回申请'
      }).value" @openQrCodeUpload="openQrCodeUpload" :form="form" @next="next" @handleMaxSize="handleMaxSize" @setResult="setResult" @handleView="handleView" @handleSuccess="handleSuccess" @handleFormatError="handleFormatError"
      @handleRemove="handleRemove"></unit-withdraw>
    <cancel-information v-if="integralUnit==$store.state.otherApplicationTypeList.find((applicationType) => {
        return applicationType.text == '注销申请人积分、配偶子女信息'
      }).value" @openQrCodeUpload="openQrCodeUpload" :form="form" @next="next" @handleMaxSize="handleMaxSize" @setResult="setResult" @getAgeByCardId="getAgeByCardId" @addChild="addChild" @handleView="handleView"
      @handleSuccess="handleSuccess" @handleFormatError="handleFormatError" @handleRemove="handleRemove" @delChild="delChild"></cancel-information>
    <!-- 结果页面 -->
    <result-view v-if="integralUnit == 100" :result="result" />
    <qr-code-upload :show="qrCodeUploadShow" @colse="colseQrCodeUpload" :qrcode="qrCodeUpload" :loading="qrCodeLoading" />

  </Card>

</template>
<script>
import '../styles/points.less'
import IntegralUnitIndex from './modules/integralUnit/index'
import PasswordReset from './modules/passwordReset/index'
import CancelInformation from './modules/cancelInformation/index'
import UnitChange from './modules/unitChange/index'
import AddressChange from './modules/addressChange/index'
import UnitWithdraw from './modules/unitWithdraw/index'
import ResultView from './modules/resultView/index'
import QrCodeUpload from '@/components/qrCodeUploadModel/index'
export default {
  // props: { form: { type: Object } },
  components: {
    IntegralUnitIndex,
    PasswordReset,
    CancelInformation,
    UnitChange,
    AddressChange,
    UnitWithdraw,
    ResultView,
    QrCodeUpload,
  },
  data() {
    return {
      qrCodeUpload: '',
      qrCodeLoading: false,
      qrCodeUploadShow: false,
      timer: null,
      otherApplicationTypeList: [],
      enterpriseAgentList: [],
      integralUnit: 0,
      ruleValidate: {
        applicationType: [
          { required: true, message: '请选择', treigger: 'change', type: 'number' },
        ],
        personnelId: [{ required: true, message: '请选择', treigger: 'change', type: 'number' }],
      },
      result: '',
      loading: false,
      form: {
        guid: null,
        enterpriseCode: null,
        enterpriseId: null,
        enterpriseName: null,
        personnelIDCardNo: null,
        personnelId: null,
        applicationType: null,
        personnelName: null,
        personnelPhone: null,
        resetPasswordType: null,
        applicantIDCardNo: null,
        applicantPhone: null,
        applicantName: null,
        applicantIDCardFrontGuid: null,
        applicantIDCardBackGuid: null,
        otherFileGuids: null,
        otherFileGuidList: [],
        otherFileGuidListPreview: [],
        hasHRPermit: false,
        hasLaborDispatchPermit: false,
        personnelLetterGuid: null,
        laborDispatchPermitGuid: null,
        hrPermitGuid: null,
        socialInsuranceRegGuidList: [],
        applicantResidencePermitFrontGuid: '',
        applicantResidencePermitBackGuid: '',
        applicantResidencePermitExpiryDate: '',
        wiithdrawReason: '',
        applicantResidencePermitAddress: '',
        isChangeDomicileAddress: null,
        changeDomicileAddress: '',
        changeDomicileAddressFileGuidList: [],
        changeDomicileAddressFileGuidListPreview: [],
        returnWorkOrderFileGuidList: [],
        laborContractFileGuidList: [],
        logoutObjectType: null,
        isLogoutSpouse: null,
        isLogoutChildren: null,
        logoutApplicationFormGuid: null,
        personnelLetterGuidPreview: [],
        socialInsuranceRegGuidListPreview: [],
        hrPermitGuidPreview: [],
        laborDispatchPermitGuidPreview: [],
        returnWorkOrderFileGuidListPreview: [],
        laborContractFileGuidListPreview: [],
        logoutApplicationFormGuidPreview: [],
        applicantPoliceStationRegistrationCertificateGuid: '',
        applicantCollectiveAccountMaterialsType: '',
        collectiveAccountMaterialsType: '',
        spouse: {
          name: '',
          idCardNo: '',
          idCardFrontGuid: '',
          idCardBackGuid: '',
          registeredResidenceType: null,
          collectiveAccountMaterialsType: '',
          policeStationRegistrationCertificateGuid: '',
          residenceBookletMainPageGuid: '',
          residenceBookletSelfPageGuid: '',
          marriageCertificateGuid: '',
          applicationId: 0,
          id: 0,
        },
        childrenList: [],
      },
      uniPersonalList: [],
      type: null,
    }
  },
  async mounted() {
    //获取*修改时
    let guid = this.$route.query.guid
    this.type = this.$route.query.type
    // 判断业务类型 获取数据
    if (guid) {
      let passwordResetType = this.$store.state.otherApplicationTypeList.find((applicationType) => {
        return applicationType.text == '密码重置'
      })
      if (this.type == passwordResetType.value) {
        // 密码重置
        this.getInitPasswordReset(guid)
      }
      return
    }
    await this.getFullInfo()

    //
  },
  watch: {
    'form.isLogoutChildren': {
      handler(val) {
        if (val) {
          this.form.childrenList = [
            {
              applicationId: 0,
              name: '',
              idCardNo: '',
              age: null,
              registeredResidenceType: null,
              residenceBookletMainPageGuid: '',
              residenceBookletSelfPageGuid: '',
              birthCertificateGuid: '',
              collectiveAccountMaterialsType: '',
              policeStationRegistrationCertificateGuid: '',
              id: 0,
            },
          ]
        } else {
          this.form.childrenList = []
        }
      },
    },
    'form.applicationType': {
      handler() {
        this.form.guid = null
      },
    },
  },
  methods: {
    // 获取初始信息
    async getFullInfo() {
      this.loading = true

      const { data } = await this.$Ajax.get(
        `/api/services/app/OtherApplicationApi/GetEnterpriseInfo`
      )
      this.enterpriseAgentList = data.result.enterpriseAgentList
      this.otherApplicationTypeList = data.result.otherApplicationTypeList

      this.$store.state.otherApplicationTypeList = data.result.otherApplicationTypeList
      this.uniPersonalList = data.result.basicData.resetPasswordTypeList
      for (let key in this.form) {
        if (key in data.result) {
          if (data.result[key]) {
            this.form[key] = data.result[key]
          }
        }
      }
      this.form.hasHRPermit = data.result.hasHRPermit
      this.form.hasLaborDispatchPermit = data.result.hasLaborDispatchPermit
      this.loading = false
    },
    // 密码重置
    async getInitPasswordReset(guid, personId) {
      this.loading = true
      let { data } = await this.$Ajax.get(
        '/api/services/app/OtherApplicationApi/GetFullInfoByResetPassword',
        { params: { guid, personId } }
      )
      this.enterpriseAgentList = data.result.enterpriseAgentList
      this.otherApplicationTypeList = data.result.basicData.otherApplicationTypeList
      this.$store.state.otherApplicationTypeList = data.result.basicData.otherApplicationTypeList
      this.uniPersonalList = data.result.basicData.resetPasswordTypeList
      for (let key in this.form) {
        if (key in data.result) {
          if (data.result[key]) {
            this.form[key] = data.result[key]
          }
        }
      }
      this.form.applicationType = parseInt(this.type)

      if (this.$route.query.current == 200) {
        this.next(this.type)
      }
      this.loading = false
    },
    //人事更改
    async personnelChange(personnel) {
      const { data } = await this.$Ajax.get(`/api/services/app/JZZJFApi/GetPersonnelInfoById`, {
        params: { id: personnel },
      })
      this.form.personnelId = data.result.personnelId
      this.form.personnelName = data.result.personnelName
      this.form.personnelIDCardNo = data.result.personnelIDCardNo
      this.form.personnelPhone = data.result.personnelPhone
    },

    next(val, name, submitUrl) {
      if (val == 0) {
        this.integralUnit = val
        return
      }
      if (!name) {
        this.integralUnit = val
        return
      }
      this.$refs[name].validate(async (valid) => {
        if (!valid) {
          this.$Message.error('请将信息填写完整')
          return
        }
        // 判断选择类型
        let passwordResetType = this.$store.state.otherApplicationTypeList.find(
          (applicationType) => {
            return applicationType.text == '密码重置'
          }
        )
        //密码重置
        if (this.form.applicationType == passwordResetType.value) {
          // this.getInitPasswordReset()
        }

        this.integralUnit = val
      })
    },
    //打开手机上传
    openQrCodeUpload(property, isArray, isReadInfo, readIdInfoAfterToView) {
      this.qrCodeUpload = ''
      this.qrCodeUploadShow = true
      this.qrCodeLoading = true
      this.getQrCode(property, isArray, isReadInfo, readIdInfoAfterToView)
    },
    //获取上传文件小程序码
    async getQrCode(property, isArray, isReadInfo, readIdInfoAfterToView) {
      let params = {}
      if (isReadInfo === 'idCard' || isReadInfo === 'spouseIdCard') {
        params.fileType = 'idcard_front'
      }
      if (isReadInfo === 'idcard_back') {
        params.fileType = 'idcard_back'
      }
      let { data } = await this.$Ajax.get('/WxApp/GetUploadFileQrcode', {
        params,
      })
      this.qrCodeUpload = data.result.imgBase64String
      this.qrCodeLoading = false
      if (data.result.uploadContextId && data.result.uploadContextId.indexOf('_') > -1) {
        data.result.uploadContextId = data.result.uploadContextId.split('_')[0]
      }
      this.getMiniUpload(
        data.result.uploadContextId,
        property,
        isArray,
        isReadInfo,
        readIdInfoAfterToView
      )
    },
    async getMiniUpload(uploadContextId, property, isArray, isReadInfo, readIdInfoAfterToView) {
      let _this = this
      let params = { uploadContextId }
      if (isReadInfo === 'idCard' || isReadInfo === 'spouseIdCard') {
        params.readIdInfo = true
      }
      if (isReadInfo === 'residencePermit') {
        params.readResidencePermit = true
      }
      if (isReadInfo === 'readEducation') {
        params.readEducation = true
      }
      const poll = async () => {
        // try {
        let { data } = await this.$Ajax.get(`/Common/File/GetUploadedFiles`, {
          params,
        })
        let response = {}
        if (data.result.length > 0) {
          response = {
            result: { ...data.result[0] },
          }
          _this.handleSuccess(
            response,
            null,
            null,
            property,
            isArray,
            isReadInfo,
            readIdInfoAfterToView
          )
          _this.colseQrCodeUpload()
          return
        }
        // if (data.result.success) {
        //   _this.colseQrCodeUpload()
        // } else {

        if (_this.qrCodeUploadShow) {
          _this.timer = setTimeout(poll, 2500)
        }
        // }
        // } catch (error) {
        //   this.$Modal.error({
        //     title: '错误',
        //     content: '获取失败！',
        //   })
        // }
      }
      poll()
    },
    colseQrCodeUpload() {
      this.qrCodeUploadShow = false
      clearTimeout(this.timer)
      this.timer = null
    },
    setResult(obj) {
      this.result = obj
    },
    //通过身份证获取年龄
    async getAgeByCardId(idCard, index) {
      let { data } = await this.$Ajax.post(
        `/api/services/app/JZZJFApi/GetAgeByIdCard?idCard=${idCard}`
      )

      if (data.result !== null) {
        // this.form.childrenList[index].age = data.result
        this.$set(this.form.childrenList[index], 'age', data.result)
      }
    },
    getGenderFromID(id) {
      // 根据身份证的第17位判断性别（奇数为男，偶数为女）
      var gender = id.charAt(16)

      if (gender % 2 === 0) {
        return '女'
      } else {
        return '男'
      }
    },
    //移除文件
    async handleRemove(file, fileList, property, isArray) {
      let _this = this
      let guid = 0

      try {
        if (file.guid) {
          guid = file.guid
        } else if (file.response) {
          guid = file.response.result.guid
        }
      } catch (error) {
        guid = 0
      }
      //   _this.form.articleImages.splice(i, 1)
      if (!this.hasDotOrBracket(property)) {
        // 是否多层属性
        //不是多层属性
        // 判断目标是否为数组，并给其赋值或者插入新数据
        if (isArray) {
          // 是数组
          let arrIndex = this.form[property].indexOf(guid)
          if (arrIndex !== -1) {
            this.form[property].splice(arrIndex, 1)
            if (this.form[property + 'Preview'] != undefined) {
              this.form[property + 'Preview'].splice(arrIndex, 1)
              // this.removeByGuid(this.form[property + 'List'], guid)
            }
          }
        } else {
          // 否则直接赋值
          this.$set(this.form, property, null)
          if (this.form[property + 'Preview'] != undefined) {
            this.removeByGuid(this.form[property + 'Preview'], guid)
          }
        }
        return
      }

      if (this.hasDotOrBracket(property)) {
        //是多层属性
        const keys = property.split(/[.\[\]]/).filter((x) => x)
        let lastIndex = keys.length - 1
        let arr = this.form
        for (let i = 0; i < lastIndex; ++i) {
          arr = arr[keys[i]]
        }
        /* 如果目标是一个数组 */
        if (isArray) {
          // 是数组
          let arrIndex = arr[keys[lastIndex]].indexOf(guid)
          if (arrIndex !== -1) {
            arr[keys[lastIndex]].splice(arrIndex, 1)
            if (arr[keys[lastIndex] + 'Preview'] != undefined) {
              _this.removeByGuid(arr[keys[lastIndex] + 'Preview'], guid)
            }
          }
        } else {
          /* 直接给对应键名键值设定数值*/
          this.setNestedValue(this.form, keys, null)
          if (arr[keys[keys.length - 1] + 'Preview'] != undefined) {
            arr[keys[keys.length - 1] + 'Preview'] = []
          }
        }
      }
    },
    //通过guid移除对象
    removeByGuid(arr, guid) {
      const index = arr.findIndex((item) => item.guid === guid)
      if (index !== -1) {
        arr.splice(index, 1)
      }
    },
    clearFileData(response, file, fileList, property, isArray, isReadInfo, readIdInfoAfterToView) {
      // 判断目标是否为数组，不是数组清空上次
      if (!isArray) {
        if (!this.hasDotOrBracket(property)) {
          //不是多层属性
          // 直接赋值
          this.$set(this.form, property, '')
          this.form[property + 'Preview'] = []
        } else {
          //是多层属性
          const keys = property.split(/[.\[\]]/).filter((x) => x)
          let lastIndex = keys.length - 1
          let arr = this.form

          for (let i = 0; i < lastIndex; ++i) {
            arr = arr[keys[i]]
          }
          /* 直接给对应键名键值设定数值*/
          this.setNestedValue(this.form, keys, '')
          //Preview赋值在后
          if (arr[keys[keys.length - 1] + 'Preview'] != undefined) {
            arr[keys[keys.length - 1] + 'Preview'] = []
          }
        }
        // 个人时不清空身份证信息
        if (
          this.$store.state.isPerson &&
          isReadInfo === 'idCard' &&
          readIdInfoAfterToView[0].name === 'applicantName'
        ) {
          return
        }
        //是否有身份证人像面信息,居住证信息
        if (
          isReadInfo === 'idCard' ||
          isReadInfo === 'residencePermit' ||
          isReadInfo === 'spouseIdCard'
        ) {
          readIdInfoAfterToView.map((el) => {
            let key = Object.keys(el)[0]
            // 赋值
            this.$set(this.form, el[key], '')
          })
        }
      }
    },
    //新增文件
    handleSuccess(response, file, fileList, property, isArray, isReadInfo, readIdInfoAfterToView) {
      try {
        if (this.$security_EncriptResponse) {
          response = this.$decryptData(response.data)
        }
      } catch {}
      this.clearFileData(
        response,
        file,
        fileList,
        property,
        isArray,
        isReadInfo,
        readIdInfoAfterToView
      )
      //身份证信息
      if (isReadInfo === 'idCard' || isReadInfo === 'spouseIdCard') {
        if (response.result.success === false) {
          this.$Modal.error({
            title: '错误',
            content: response.result.message,
          })
          return
        }
        if (!(response.result.idCard && response.result.name)) {
          this.$Modal.error({
            title: '错误',
            content: '身份证图片识别失败，请上传清晰完整的身份证人像面图片！',
          })
          return
        }
        //个人申请时
        if (isReadInfo === 'idCard' && this.$store.state.isPerson) {
          if (this.form.applicantIDCardNo.toLowerCase() != response.result.idCard.toLowerCase()) {
            this.$Modal.error({
              title: '错误',
              content: '身份证不符合当前登录人，请重新上传！',
            })
            return
          }
        }
        //配偶时
        if (isReadInfo === 'spouseIdCard') {
          let applicantSex = this.getGenderFromID(this.form.applicantIDCardNo)

          if (applicantSex == response.result.sex) {
            this.$Modal.error({
              title: '错误',
              content: '配偶身份证不符合实际情况，请重新上传！',
            })
            return
          }
        }
      }
      //身份证背面 先判断
      if (isReadInfo === 'idcard_back') {
        if (response.result.isIDCardBackRecognizeSuccessful === false) {
          this.$Modal.error({
            title: '错误',
            content: '身份证国徽面无法识别，请上传正确清晰的身份证国徽面图片！',
          })
          return
        }
        if (response.result.isIDCardValidityPassed === false) {
          this.$Modal.error({
            title: '错误',
            content: '身份证已过期，不允许申请！',
          })
          return
        }
      }

      //居住证信息
      if (isReadInfo === 'residencePermit') {
        if (!response.result.residencePermitExpiryDate) {
          this.$Modal.error({
            title: '错误',
            content: '居住证图片识别失败，请上传清晰完整的居住证正面图片！',
          })
          return
        }
        //判断居住证姓名和身份证姓名是否一致
        if (response.result.name && response.result.name != this.form.applicantName) {
          this.$Modal.error({
            title: '错误',
            content: '居住证姓名与绑定的身份证不符！',
          })
          return
        }
        //判断身份证号和身份证号是否一致
        if (
          response.result.idCard == null ||
          response.result.idCard.toLowerCase() != this.form.applicantIDCardNo.toLowerCase()
        ) {
          this.$Modal.error({
            title: '错误',
            content: '居住证身份证号与绑定的身份证不符！',
          })
          return
        }

        if (response.result.isResidencePermitValidityPassed === false) {
          this.$Modal.error({
            title: '错误',
            content: '有效期不足2个月，请更新有效期',
          })
          return
        }
      }
      if (!this.hasDotOrBracket(property)) {
        // 是否多层属性

        //不是多层属性
        // 判断目标是否为数组，并给其赋值或者插入新数据
        if (isArray) {
          // 是数组
          // if (this.form[property] == undefined) {
          if (!Array.isArray(this.form[property])) {
            //不存在先创建
            this.$set(this.form, property, [])
          }
          let isExistGUID = this.form[property].some((arrele) => arrele === response.result.guid)
          //是否存在,已存在不往下执行
          if (isExistGUID) {
            return
          }
          this.form[property].push(response.result.guid)
          this.form[property + 'Preview'].push({
            guid: response.result.guid,
            name: response.result.fileName,
            url: response.result.imageUrl,
          })
        } else {
          // 否则直接赋值
          this.$set(this.form, property, response.result.guid)
          if (this.form[property + 'Preview'] != undefined) {
            this.form[property + 'Preview'] = []
            this.form[property + 'Preview'].push({
              guid: response.result.guid,
              name: response.result.fileName,
              url: response.result.imageUrl,
            })
          }
        }
      }

      if (this.hasDotOrBracket(property)) {
        //是多层属性
        const keys = property.split(/[.\[\]]/).filter((x) => x)
        let lastIndex = keys.length - 1
        let arr = this.form

        for (let i = 0; i < lastIndex; ++i) {
          arr = arr[keys[i]]
        }

        /* 如果目标是一个数组 */
        // if (Array.isArray(arr[keys[lastIndex]])) {
        if (isArray) {
          // 是数组
          if (!Array.isArray(arr[keys[lastIndex]])) {
            //不存在先创建
            // this.$set(this.form,arr[keys[lastIndex]],[])
            arr[keys[lastIndex]] = []
          }
          let isExistGUID = arr[keys[lastIndex]].some((arrele) => arrele === response.result.guid)
          //是否存在,已存在不往下执行
          if (isExistGUID) {
            return
          }
          arr[keys[lastIndex]].push(response.result.guid)

          if (arr[keys[lastIndex] + 'Preview'] != undefined) {
            arr[keys[lastIndex] + 'Preview'].push({
              guid: response.result.guid,
              name: response.result.fileName,
              url: response.result.imageUrl,
            })
          }
        } else {
          //不是数组/
          /* 直接给对应键名键值设定数值*/
          this.setNestedValue(this.form, keys, response.result.guid)
          //Preview赋值在后
          if (arr[keys[keys.length - 1] + 'Preview'] != undefined) {
            arr[keys[keys.length - 1] + 'Preview'] = [
              {
                guid: response.result.guid,
                name: response.result.fileName,
                url: response.result.imageUrl,
              },
            ]
          }
        }
      }
      //是否有身份证人像面信息,居住证信息
      if (
        isReadInfo === 'idCard' ||
        isReadInfo === 'residencePermit' ||
        isReadInfo === 'spouseIdCard'
      ) {
        readIdInfoAfterToView.map((el) => {
          let key = Object.keys(el)[0]
          if (
            key == 'residencePermitExpiryDate' &&
            response.result[key] != null &&
            response.result[key] != ''
          ) {
            response.result[key] = new Date(response.result[key])
          }
          if (response.result[key] != null && response.result[key] != '') {
            this.$set(this.form, el[key], response.result[key])
          }
        })
      }

      //是否有学历学位信息
      if (isReadInfo === 'readEducation') {
        if (this.currentStep !== this.$store.state.appInfoDataType['专科学历信息']) {
          for (let key in response.result.educationInfo) {
            if (key in this.form) {
              if (
                response.result.educationInfo[key] != null &&
                response.result.educationInfo[key] != ''
              ) {
                if (key == 'enrolDate' || key == 'graduationDate') {
                  response.result.educationInfo[key] = new Date(response.result.educationInfo[key])
                }
                this.form[key] = response.result.educationInfo[key]
              }
            }
          }
        } else {
          //专升本
          for (let key in response.result.educationInfo) {
            if (key in this.form) {
              if (
                response.result.educationInfo[key] != null &&
                response.result.educationInfo[key] != ''
              ) {
                if (key == 'enrolDate' || key == 'graduationDate') {
                  response.result.educationInfo[key] = new Date(response.result.educationInfo[key])
                }
                this.form.juniorCollegeEducation[key] = response.result.educationInfo[key]
              }
            }
          }
          this.form.juniorCollegeEducation.educationType = 2 //专科学历不随文件变
        }
      }
      this.form = this.form
      // this.form[property]
    },
    //查看图片文件
    handleView(guid) {
      let _this = this

      const $viewer = this.$viewerApi({
        options: {
          toolbar: true,
          initialViewIndex: 0,
        },
        images: [_this.$baseURL + '/file/preview/' + guid],
      })
    },

    //判断字符串是不是有.  [  ]
    hasDotOrBracket(str) {
      const regex = /[.\[\]]/
      return regex.test(str)
    },
    //字符串转多层属性 处理
    setNestedValue(obj, keys, value) {
      let lastKey = null
      keys.forEach((key, i) => {
        if (i === keys.length - 1) {
          obj[key] = value // 到达最内层赋值给目标属性
        } else {
          if (!obj[key]) {
            // 如果当前层次还不存在，则初始化他
            this.$set(obj, key, {})
          }
          obj = obj[key]
        }
      })
    },
    //文件格式错误
    handleFormatError(file) {
      // this.$Notice.warning({
      //   title: '文件格式错误',
      //   // desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
      // })
      this.$Message.error({
        content: '文件格式错误',
        background: true,
        duration: 6,
      })
    },
    //移除表单验证
    resmove(name) {
      this.$refs[name].resetFields()
    },
    //文件大小超出
    handleMaxSize(file) {
      this.$Message.error({
        content: '文件' + file.name + ' 过大, 请上传小于5M的文件',
        background: true,
        duration: 6,
      })
    },
    //添加子项
    addChild(property) {
      if (!Array.isArray(this.form[property])) {
        this.$set(this.form, property, [])
      }
      //子女信息
      this.form[property].push({
        applicationId: 0,
        name: '',
        idCardNo: '',
        age: null,
        registeredResidenceType: null,
        residenceBookletMainPageGuid: '',
        residenceBookletSelfPageGuid: '',
        birthCertificateGuid: '',
        id: 0,
      })
    },
    //删除子项
    delChild(property, index) {
      this.form[property].splice(index, 1)
    },
  },
}
</script>
<style lang="less" scoped>
.main {
  display: flex;
  flex-direction: column;
  //border: 1px solid red;
  //justify-content: center;
  //align-items: center;

  //border: 1px solid red;
  .group {
    //flex: 1;
    //border: 1px solid red;
    height: 300px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    //align-items: center;

    .gp {
      display: flex;
      flex-direction: column;
      justify-content: start;
      //border: 1px solid blue;
      height: 80px;
    }
  }
}
.bom_btn {
  padding: 20px;
  // width: 50%;
  display: flex;
  justify-content: space-around;

  .ivu-btn {
    padding: 0px 30px;
    margin: 0px 40px;
  }
}
</style>
